import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppInternalDesktopConfiguration } from '../../models/desktop/app-internal-desktop-configuration.model';
import { DeptAppsDesktopConnectionEndpointService } from './internal/deptapps-desktop-connection-endpoint.service';
import { UserDesktopPreferences } from '../../models/desktop/user-desktop-preferences.model';

@Injectable()
export class UserDesktopPreferencesService {

  constructor(
    private deptappsDesktopConnectionEndpointService: DeptAppsDesktopConnectionEndpointService,
    private http: HttpClient) { }

  async findUniqueRow(): Promise<UserDesktopPreferences> {
    const resourceBaseUri = await this.buildResourceBaseUri();
    return await this.http.get<UserDesktopPreferences>(encodeURI(resourceBaseUri)).toPromise();
  }

  private async buildResourceBaseUri() {
    const { httpConnectionBaseUrl } = await this.deptappsDesktopConnectionEndpointService.getConnectionEndpoint();
    return `${httpConnectionBaseUrl}/app/desktop/user-desktop-preferences`;
  }
}
